export const colors = {
  primary: "#1c407b",
  secondary: "#e31e24",
  white: "#fff",
};
export const CLASS_COLOR_MAP = {
  "00": "#4AB8C0", // Blue-green
  0: "#F5A9A9", // Light Red
  1: "#D9A6A6", // Rosy Brown
  2: "#A5CCCC", // Light Blue-Gray
  3: "#CC6666", // Reddish Brown
  4: "#468FAF", // Dark Blue
  5: "#8085e9", // Light Purple
  6: "#f15c80", // Pink
  11: "#4AB8C0", // Blue-green
  7: "#F5A9A9", // Light Red
  8: "#D9A6A6", // Rosy Brown
  9: "#A5CCCC", // Light Blue-Gray
  10: "#CC6666", // Reddish Brown
  12: "#468FAF", // Dark Blue
  Insulating: "#4AB8C0",
  Arc: "#F5A9A9",
  Composite: "#D9A6A6",
  TEL: "#A5CCCC",
  // Add more class names and their desired colors as needed
  // You can also add a default color for classes not explicitly listed
  "Default Class Color": "#CCCCCC", // Grey
};

export const getChartColor = (className) => {
  return CLASS_COLOR_MAP[className] || CLASS_COLOR_MAP["Default Class Color"];
};
